import { render, staticRenderFns } from "./events-promotion.vue?vue&type=template&id=4c36a474"
import script from "./events-promotion.vue?vue&type=script&lang=js"
export * from "./events-promotion.vue?vue&type=script&lang=js"
import style0 from "./events-promotion.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports